import {Component} from '@angular/core';
import {TextChangeService} from "../../../modules/shared/services/text-change.service";

@Component({
    selector: 'ngx-footer',
    styleUrls: ['./footer.component.scss'],
    template: `
        <div class="d-block w-100">
            <span class="created-by">{{changeTextService.changeText('copyright', {year : ''+year})}}|
                <a class="link" [attr.aria-label]="'footer.privacyPolicy' | translate" routerLink="/public/privacy-policy" target="_blank">{{ 'footer.privacyPolicy' | translate }}</a> |
                <a class="link" [attr.aria-label]="'footer.cookiePolicy' | translate" routerLink="/public/cookie-policy" target="_blank">{{ 'footer.cookiePolicy' | translate }}</a> |
                <a class="link" [attr.aria-label]="'footer.termsConditions' | translate" routerLink="/public/terms-conditions" target="_blank">{{ 'footer.termsConditions' | translate }}</a> |
                <a class="link" [attr.aria-label]="'footer.legalNotes' | translate" routerLink="/public/legal-notes" target="_blank">{{ 'footer.legalNotes' | translate }}</a>
            </span>
        </div>
    `,
})

export class FooterComponent {
  constructor(public changeTextService : TextChangeService) {
  }
    year = new Date().getFullYear();
}
